import { render, staticRenderFns } from "./ChurchOfTheHolyTrinity.vue?vue&type=template&id=b974511c&"
import script from "./ChurchOfTheHolyTrinity.vue?vue&type=script&lang=js&"
export * from "./ChurchOfTheHolyTrinity.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports